import React from 'react';
import { useNavigate } from 'react-router-dom';
import CountrySelector from '../components/CountrySelector';
import { supabase } from '../lib/supabase';

export default function CountrySetup() {
  const navigate = useNavigate();

  const handleCountrySelected = async (countryCode: string, countryName: string) => {
    try {
      // Also save to profiles table if user has a profile
      const { data: { user } } = await supabase.auth.getUser();
      
      if (user) {
        // Update or create profile with country info
        await supabase
          .from('profiles')
          .upsert({
            id: user.id,
            country_code: countryCode,
            country: countryName,
            updated_at: new Date().toISOString(),
          });
      }
    } catch (error) {
      console.error('Error saving country to profile:', error);
    }
  };

  const handleContinue = () => {
    navigate('/', { replace: true });
  };

  return (
    <CountrySelector
      onCountrySelected={handleCountrySelected}
      onContinue={handleContinue}
      title="Welcome! One more step..."
      description="To provide you with the best experience, please select your country"
    />
  );
} 